export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="border-t bg-white">
      <div className="mx-auto flex max-w-6xl flex-col items-center justify-between gap-3 px-4 py-6 text-sm text-slate-600 sm:flex-row">
        <p>© {year} PFA Pocei Marius-Gheorghe</p>
        <div className="flex items-center gap-4">
          <a href="tel:+40744476911" className="hover:text-slate-900">+40 744 476 911</a>
          <a href="mailto:marius.pocei@gmail.com" className="hover:text-slate-900">marius.pocei@gmail.com</a>
        </div>
      </div>
    </footer>
  );
}
